import AccessStatus from "../views/AccessStatus.vue";
import RPImageRepo from "../views/RPImageRepo.vue";
import CreateUser from "../views/CreateUser.vue";
import ModifyUser from "../views/ModifyUser.vue";
import CreatePark from "../views/CreatePark.vue";
import GetQRFromPark from "../views/GetQRFromPark.vue";
import GetManagersFromPark from "../views/GetManagersFromPark.vue";
import GetCSFromQR from "../views/GetCSFromQR.vue";
import AddMoneyDest from "../views/AddMoneyDest.vue";
import ModifyMoneyDest from "../views/ModifyMoneyDest.vue";
import AddIpsum from "../views/AddIpsum.vue";
import ModifyIpsum from "../views/ModifyIpsum.vue";
import Newcomers from "../views/Newcomers.vue";
import AddPms from "../views/AddPms.vue";
import AddPMSPendingReq from "../views/AddPMSPendingReq.vue";
import GetReceipt from "../views/GetReceipt.vue";
import FrontendMedia from "../views/FrontendMedia.vue";
import ParkImageMedia from "../views/ParkImageMedia.vue";
import ManualBonk from "../views/ManualBonk.vue";
import ModifyPark from "../views/ModifyPark.vue";
import GetParkFromMD from "../views/GetParkFromMD.vue";
import GetReceiptPark from "../views/GetReceiptPark.vue";
import PaymentOrders from "../views/PaymentOrders.vue";
import ModifyAgency from "../views/ModifyAgency.vue";
import Accounting from "@/views/Accounting.vue";
import CreateClient from "@/views/CreateClient.vue";
import ModifyClient from "@/views/ModifyClient.vue";
import IssuesPage from "@/views/IssuesPage.vue";
import MaintenanceMap from "@/views/MaintenanceMap.vue";
import InitDoMaint from "@/views/InitDoMaint.vue";
import ShowDoMaintenance from "@/views/ShowDoMaintenance.vue";

export const schema = [
  {
    name: "General status/management",
    routes: [
      {
        route: '/accessstatus/',
        name: 'Access Status',
        component: AccessStatus
      },
      {
        route: '/rpimagereporedirect/',
        name: 'RPi image repository',
        component: RPImageRepo
      }
    ]
  },
  {
    name: "Users",
    routes: [
      {
        route: '/createuser/',
        name: 'Create User',
        component: CreateUser
      }, {
        route: '/modifyuser/',
        name: 'Modify User',
        component: ModifyUser
      }
    ]
  },
  {
    name: "Parks",
    routes: [
      {
        route: '/createpark/',
        name: 'Create Park',
        component: CreatePark
      },
      {
        route: '/modifypark',
        name: 'Modify Park',
        component: ModifyPark,
      },
      {
        route: '/getqrfrompark/',
        name: 'Get QR from Park',
        component: GetQRFromPark
      },
      {
        route: '/getmanagersfrompark/',
        name: 'Get Managers from Park',
        component: GetManagersFromPark
      },
      {
        route: '/getcsfromqr/',
        name: 'Get CS from QR',
        component: GetCSFromQR
      }
    ]
  },
  {
    name: "Maintenance",
    routes: [
      {
        route: '/initdomaintenance/',
        name: "Do Maintenance",
        component: InitDoMaint,
      },
      {
        route: '/showdomaintenance/',
        name: "Show Done Maintenance",
        component: ShowDoMaintenance,
      },
      {
        route: '/issuepanel/',
        name: "Issue Panel",
        component: IssuesPage
      },
      {
        route: '/maptenance/',
        name: 'Manteinance map',
        component: MaintenanceMap
      }
    ]
  },
  {
    name: "Money Destinations",
    routes: [
      {
        route: '/addmoneydest/',
        name: 'Add Money Destination',
        component: AddMoneyDest
      },
      {
        route: '/modifymoneydest/',
        name: 'Modify Money Destination',
        component: ModifyMoneyDest
      },
      {
        route: '/getparkfrommd',
        name: 'Get Park from MD',
        component: GetParkFromMD
      }
    ]
  },
  {
    name: "Ipsum",
    routes: [
      {
        route: '/addipsumdevice/',
        name: 'Add Ipsum',
        component: AddIpsum
      },
      {
        route: '/modifyipsumdevice/',
        name: 'Modify Ipsum',
        component: ModifyIpsum
      }
    ]
  },
  {
    name: "Explorers",
    routes: [
      {
        route: '/paymentorders/',
        name: 'Payment Orders',
        component: PaymentOrders
      }
    ]
  },
  {
    name: "Accounting",
    routes: [
      {
        route: '/accounting/',
        name: 'Accounting',
        component: Accounting
      },
      {
        route: '/newclient/',
        name: 'New Client',
        component: CreateClient
      },
      {
        route: '/modifyclient/',
        name: 'Modify Client',
        component: ModifyClient
      }
    ]
  },
  {
    name: "Bonk",
    routes: [
      {
        route: '/manualbonk/',
        routeParams: ['urlRemoteName'],
        name: 'Manual Bonk',
        component: ManualBonk,
      }
    ]
  },
  {
    name: "Newcomers",
    routes: [
      {
        route: '/newcomers/',
        name: 'Newcomers',
        component: Newcomers
      }
    ]
  },
  {
    name: "PMS",
    routes: [
      {
        route: '/addpms/',
        name: 'Add/Check PMS',
        component: AddPms
      },
      {
        route: '/addpmspr/',
        name: 'Add/Check Pending Request',
        component: AddPMSPendingReq
      }
    ]
  },
  {
    name: "Email Reports",
    routes: [
      {
        route: '/getreceipt/',
        name: 'Get Receipts',
        component: GetReceipt
      },
      {
        route: '/getreceiptpark/',
        name: 'Get Users Report',
        component: GetReceiptPark
      },
    ]
  },
  {
    name: "Media",
    routes: [
      {
        route: '/femedia/',
        name: 'Frontend Media',
        component: FrontendMedia
      },
      {
        route: '/pimedia/',
        name: 'Park Image Media',
        component: ParkImageMedia
      }
    ]
  },
  {
    name: "Agency/Antennas",
    routes: [
      {
        route: '/modifyAgency/',
        name: 'Modify Agency',
        component: ModifyAgency
      }
    ]
  }
];

export function generateRouting() {
  let out: any[] = [];
  for (const i in schema) {
    const routelist = schema[i];
    for (const j in routelist.routes) {
      const route = routelist.routes[j];
      const meta = route['meta'] || {};
      let urlRoute = route['route'];
      urlRoute = urlRoute.endsWith('/') ? urlRoute : urlRoute + '/';
      if (route['routeParams'] !== undefined) {
        const routeParams = route['routeParams'].map((str: string) => ':' + str);
        out.push({
          path: urlRoute, component: route['component'], meta: meta
        });
        urlRoute = urlRoute + routeParams.join('/');
      }
      out.push({
        path: urlRoute, component: route['component'], meta: meta
      });
    }
  }
  return out;
}
